var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexbox",class:[_vm.classDirection, _vm.classWrap, _vm.classJustify, _vm.classAlign]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }